import { render, staticRenderFns } from "./CaptureSignature.vue?vue&type=template&id=5f89acf2&"
import script from "./CaptureSignature.vue?vue&type=script&lang=ts&"
export * from "./CaptureSignature.vue?vue&type=script&lang=ts&"
import style0 from "./CaptureSignature.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
